import ApiService from "./api.service";

const BoosterService = {
  async calculate(id) {
    try {
      return await ApiService.get(`boosters/calculate/${id}`);
    } catch (error) {
      console.log(error);
    }
  },
  async storeDocuments(data) {
    try {
      return await ApiService.post(`booster-documents`, data, {
        "Content-Type": "multipart/form-data",
      });
    } catch (error) {
      console.log(error);
    }
  },
};

export { BoosterService };
